import {IAnalyticsMeta} from 'core/types';
import {GoogleAnalyticsService} from 'modules/google-analytics/service';

export const checkIsGFEvent = (analytics: IAnalyticsMeta) => {
    return Boolean(analytics.listName?.toLowerCase().includes('gf')) || analytics.variationsId || analytics.decisionId;
};

export function sendGtagEvent(eventData: Record<string, any>) {
    GoogleAnalyticsService.gtag(eventData);
}
